<template>
  <div class="aph">
    <p class="aph-nota">
      <v-icon size="15" color="#8a939c">mdi-information-outline</v-icon>
      <span v-if="tipo === 'criados'"
        >Hotéis que a CVC mandou com um nome que o Phoenix não conhecia e que o
        agente identificou com certeza: ele cadastrou o apelido e corrigiu a
        reserva. Clique para ver os candidatos e o nível de certeza.</span
      >
      <span v-else
        >Hotéis que o agente avaliou mas <strong>não teve certeza</strong> (ou
        que só foram simulados): nada foi gravado. A reserva segue em correção
        manual, com a sugestão abaixo.</span
      >
    </p>

    <div v-if="items.length" class="detail-table-wrap">
      <table class="detail-table aph-table">
        <colgroup>
          <col class="col-chevron" />
          <col />
          <col class="col-hotel" />
          <col class="col-cert" />
          <col class="col-reserva" />
          <col class="col-data" />
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th>Nome que a CVC mandou</th>
            <th>{{ tipo === "criados" ? "Hotel no Phoenix" : "Melhor candidato" }}</th>
            <th>Certeza</th>
            <th>Reserva</th>
            <th>Quando</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="a in items">
            <tr
              :key="a.id"
              class="aph-row"
              :class="{ 'is-open': aberto === a.id }"
              @click="aberto = aberto === a.id ? null : a.id"
            >
              <td class="aph-chevron">
                <v-icon
                  size="18"
                  class="aph-chev"
                  :class="{ 'is-open': aberto === a.id }"
                  >mdi-chevron-right</v-icon
                >
              </td>
              <td class="aph-apelido">
                {{ a.apelido }}
                <span v-if="a.resultado === 'simulada'" class="aph-tag aph-tag--sim"
                  >Simulação</span
                >
                <span v-else-if="a.resultado === 'ja_existia'" class="aph-tag"
                  >apelido já existia</span
                >
                <span v-else-if="a.resultado === 'erro'" class="aph-tag aph-tag--erro"
                  >erro</span
                >
              </td>
              <td>{{ a.hotel ? a.hotel.name : "—" }}</td>
              <td>
                <span v-if="a.confianca != null" class="aph-cert" :class="certClasse(a)"
                  >{{ a.confianca }}%</span
                >
                <span v-if="a.nivel && a.nivel !== 'existente'" class="muted">
                  {{ a.nivel }}</span
                >
              </td>
              <td class="voucher-cell">{{ a.reserva || a.voucher || "—" }}</td>
              <td class="muted">{{ a.ultimaVez }}</td>
            </tr>
            <tr v-if="aberto === a.id" :key="a.id + '-det'" class="aph-det">
              <td colspan="6">
                <div class="aph-blocos">
                  <div v-if="a.motivo" class="aph-bloco">
                    <div class="aph-titulo">
                      {{ tipo === "criados" ? "O que o agente fez" : "Por que não agiu" }}
                    </div>
                    <p class="aph-texto">{{ a.motivo }}</p>
                  </div>
                  <div class="aph-bloco">
                    <div class="aph-titulo">Candidatos avaliados</div>
                    <table v-if="a.candidatos.length" class="aph-dif">
                      <thead>
                        <tr>
                          <th>Hotel no cadastro</th>
                          <th class="num">Certeza</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(c, k) in a.candidatos"
                          :key="k"
                          :class="{ 'aph-escolhido': a.hotel && c.id === a.hotel.id }"
                        >
                          <td>
                            {{ c.name }}
                            <span class="muted"> · id {{ c.id }}</span>
                            <span v-if="c.viaApelido" class="muted">
                              · via apelido "{{ c.viaApelido }}"</span
                            >
                          </td>
                          <td class="num">{{ c.confianca }}%</td>
                        </tr>
                      </tbody>
                    </table>
                    <p v-else class="muted">Nenhum hotel parecido no cadastro.</p>
                  </div>
                  <div v-if="a.servicos.length" class="aph-bloco">
                    <div class="aph-titulo">Serviços corrigidos na reserva</div>
                    <p class="aph-texto">
                      {{
                        a.servicos
                          .map((s) => (s.tipo === "IN" ? "IN (destino)" : "OUT (origem)"))
                          .join(" e ")
                      }}
                    </p>
                  </div>
                  <div v-if="tipo !== 'criados' && a.sugestao" class="aph-bloco">
                    <div class="aph-titulo">Sugestão para a equipe</div>
                    <p class="aph-texto">{{ a.sugestao }}</p>
                  </div>
                  <p v-if="a.cliente" class="muted aph-cliente">
                    Cliente: {{ a.cliente }} · voucher {{ a.voucher || "—" }}
                  </p>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tfoot v-if="meta.listadas < meta.total">
          <tr>
            <td colspan="6">
              Listando {{ meta.listadas }} de {{ meta.total }} no período.
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div v-else class="detail-empty detail-empty--ok">
      <v-icon size="18" color="#0f7a6e">mdi-check-circle-outline</v-icon>
      {{
        tipo === "criados"
          ? "O agente não cadastrou nenhum apelido de hotel neste período."
          : "Nenhum hotel ficou sem certeza neste período."
      }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ApelidosHotel",
  props: {
    // 'criados' = cadastrados pelo agente (ou que ja existiam); 'incertos' = duvida, simulacao ou erro
    tipo: { type: String, default: "criados" },
    items: { type: Array, default: () => [] },
    meta: { type: Object, default: () => ({ total: 0, listadas: 0 }) },
  },
  data() {
    return { aberto: null };
  },
  methods: {
    certClasse(a) {
      if (a.resultado === "criado" || a.resultado === "ja_existia")
        return "aph-cert--alta";
      if (a.confianca >= 80) return "aph-cert--media";
      return "aph-cert--baixa";
    },
  },
};
</script>

<style scoped lang="scss">
@import "../_shared/detail.scss";

.aph-nota {
  display: flex;
  gap: 6px;
  align-items: flex-start;
  margin: 0 0 12px;
  color: #6b747d;
  font-size: 0.85rem;
}
.aph-table {
  col.col-chevron {
    width: 36px;
  }
  col.col-hotel {
    width: 240px;
  }
  col.col-cert {
    width: 130px;
  }
  col.col-reserva {
    width: 130px;
  }
  col.col-data {
    width: 140px;
  }
}
.aph-row {
  cursor: pointer;

  &:hover,
  &.is-open {
    background: #f6f8fa;
  }
}
.aph-chevron {
  padding-right: 0;
}
.aph-chev {
  transition: transform 0.15s ease;

  &.is-open {
    transform: rotate(90deg);
  }
}
.aph-apelido {
  font-weight: 600;
  word-break: break-word;
}
.aph-tag {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 0.72rem;
  font-weight: 600;
  background: #eef2f6;
  color: #55606c;

  &--sim {
    background: #e8f0fe;
    color: #1d4ea8;
  }
  &--erro {
    background: #fdeeee;
    color: #a33a3a;
  }
}
.aph-cert {
  display: inline-block;
  padding: 1px 9px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.8rem;
  margin-right: 4px;

  &--alta {
    background: #eaf6f1;
    color: #0b5f55;
  }
  &--media {
    background: #fdf0dc;
    color: #b06a12;
  }
  &--baixa {
    background: #fdeeee;
    color: #a33a3a;
  }
}
.aph-det > td {
  background: #fafbfc;
  padding: 12px 16px 16px 44px;
}
.aph-blocos {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.aph-titulo {
  font-weight: 600;
  font-size: 0.85rem;
  margin-bottom: 4px;
}
.aph-texto {
  margin: 0;
  font-size: 0.88rem;
  word-break: break-word;
}
.aph-cliente {
  margin: 0;
  font-size: 0.8rem;
}
.aph-dif {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;

  th,
  td {
    text-align: left;
    padding: 6px 10px;
    border-bottom: 1px solid #e6eaee;
    vertical-align: top;
  }
  th {
    color: #6b747d;
    font-weight: 600;
  }
  .num {
    text-align: right;
    white-space: nowrap;
  }
}
.aph-escolhido td {
  background: #eaf6f1;
  font-weight: 600;
}
</style>
